import React, { useState } from "react";

import { HiDotsVertical } from "react-icons/hi";
import { IoIosRadioButtonOff } from "react-icons/io";
import { SiAcclaim } from "react-icons/si";
import { BsMicFill, BsMicMuteFill } from "react-icons/bs";
import { IoVolumeMedium, IoVolumeMute } from "react-icons/io5";
import { WiMoonWaxingCrescent4 } from "react-icons/wi";
import { FcCancel } from "react-icons/fc";
import { SiCanonical } from "react-icons/si";

import "./userstate.css";

const UserState = () => {
  const [bigCircl, setBigCircl] = useState("");
  const [smallCircl, setSmallCircl] = useState("");

  const [mike, setMike] = useState(false);
  const [speaker, setSpeaker] = useState(false);

  const [menuTrue, setMenuTrue] = useState(false);

  const userStateMenu = () => {
    console.log("user menu");
  };

  const userStateFunc = (state) => {
    if (state == "online") {
      setBigCircl("");
      setSmallCircl("");
    }

    if (state == "idle") {
      setBigCircl("idl_big_circl");
      setSmallCircl("idl_small_circl");
    }

    if (state == "disturb") {
      setBigCircl("disturb_big_Circl");
      setSmallCircl("disturb_small_Circl");
    }

    if (state == "invisible") {
      setBigCircl("invisible_big_Circl");
      setSmallCircl("invisible_small_Circl");
    }
  };

  return (
    <div className={`bottom_user_state`}>
      <span className={`openMenu`} onClick={() => setMenuTrue(true)}>
        <SiAcclaim />
      </span>
      {menuTrue && (
        <div className={`${`menu`} menu`}>
          <button className={`closeMenu`} onClick={() => setMenuTrue(false)}>
            X
          </button>
          <button onClick={() => userStateFunc("online")} className="online">
            Online <IoIosRadioButtonOff className="online-icon" />
          </button>
          <button onClick={() => userStateFunc("idle")} className="idle">
            Idle <WiMoonWaxingCrescent4 className="idle-icon" />
          </button>
          <button onClick={() => userStateFunc("disturb")} className="disturb">
            Do Not Disturb <FcCancel className="disturb-icon" />
          </button>
          <button
            onClick={() => userStateFunc("invisible")}
            className="invisiblestate"
          >
            Invisible <SiCanonical className="invisible-icon" />
          </button>
        </div>
      )}
      <button onClick={() => setMenuTrue(!menuTrue)} className={`user_state`}>
        <div className={`big_circl ${bigCircl} `}>
          <div className={`small_circl ${smallCircl} `}></div>
        </div>
      </button>

      <button className={`user_name`}>Youssef Mahmoud</button>

      <div className={`user_icons`}>
        <button onClick={() => setMike(!mike)} className={`mike_icon`}>
          {mike ? <BsMicFill /> : <BsMicMuteFill />}
        </button>
        <button onClick={() => setSpeaker(!speaker)} className={`speaker`}>
          {speaker ? <IoVolumeMedium /> : <IoVolumeMute />}
        </button>
        <button onClick={userStateMenu} className={`sittings`}>
          <HiDotsVertical />
        </button>
      </div>
    </div>
  );
};

export default UserState;
